import { router } from './router';
import { menu } from './menu';

export const CorporateSegment = {
	menu,
	router,
};
